module.exports = __webpack_public_path__ + "img/ml.eb4e63d0.svg";